import { Col } from "react-bootstrap";
import "./jobList.css";
import Tab from "react-bootstrap/Tab";
import ShortcutIcon from "@mui/icons-material/Shortcut";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Tabs from "react-bootstrap/Tabs";
import { Form, FormControl, Dropdown } from "react-bootstrap";
import { useLazySearchCompanyByNameQuery } from "../../../../features/user/userApiSlice";
import Adds from "../../../../components/shopAds/ShopAdds";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import ShareModel from "../../../../components/Sharemodel";
import ShareOption from "../../../../components/Shareoption";

const JobList = ({ itemData, companyJobs = [], companyJobsLoading = false }) => {
  const [showoneModal, setShowoneModal] = useState(false);
  const [showshare, setShowshare] = useState(0);
  const [show, setShow] = useState(0);
  const [shareurl, setShareurl] = useState("");

  const handleCloseshare = () => {
    setShowshare(0);
    setShow(1);
  };

  const handleClosemodal = () => {
    setShow(0);
  };

  const handleShowshare = () => {
    setShow(0);
    setShowshare(1);
  };

  const handleTabSelect = (eventKey) => {
    if (eventKey === "tab1") {
      setShowoneModal(true);
    }
  };

  const navigate = useNavigate();
  const [companysearchdata, setCompanysearchdata] = useState();
  const [showDropdown, setShowDropdown] = useState(false);

  const [triggerSearchCompany] = useLazySearchCompanyByNameQuery();

  const handleFocus = () => {
    setShowDropdown(true);
  };

  const filterData = (e) => {
    triggerSearchCompany({ title: e, businessType: "jobsCompany" })
      .unwrap()
      .then((res) => {
        setCompanysearchdata(res?.data?.Companies);
      })
      .catch((error) => console.error("Error fetching companies:", error));
  };
  const handleBlur = () => {
    // Delay the dropdown hide to allow clicks to register on dropdown items
    setTimeout(() => setShowDropdown(false), 100);
  };

  // Prefer jobs actually posted by this company; only fall back to the
  // shared/global itemdata slice (legacy behaviour) if that fetch has
  // nothing, so we don't silently drop any previously-working flow.
  const jobsToShow =
    companyJobs && companyJobs.length > 0 ? companyJobs : itemData?.itemdata || [];

  const renderJobRow = (jobs) => (
    <div className="company-job-entry" key={jobs?._id}>
      <div className="company-job-row-scroll">
        <div className="company-job-row">
          <div className="company-job-cell">
            <div>
              <p className="mb-1 jobPara">Designation</p>
              <h6 className="jobsDesc company-job-value" title={jobs?.title || "N/A"}>
                {jobs?.title || "N/A"}
              </h6>
            </div>
          </div>
          <div className="company-job-cell">
            <div>
              <p className="mb-1 jobPara">Posted date</p>
              <h6 className="jobsDesc company-job-value">
                {jobs?.createdAt ? String(jobs.createdAt).slice(0, 10) : "N/A"}
              </h6>
            </div>
          </div>
          <div className="company-job-cell">
            <div>
              <p className="mb-1 jobPara">Last date of apply</p>
              <h6 className="jobsDesc company-job-value">{jobs?.duration || "N/A"}</h6>
            </div>
          </div>
          <div className="company-job-cell company-job-action">
            <div>
              <p className="mb-1 jobPara">View details</p>
              <div className="cursor d-flex justify-content-center">
                <VisibilityIcon
                  className="viewBlue"
                  onClick={() => navigate(`/view-job-details/${jobs?._id}`)}
                />
              </div>
            </div>
          </div>
          <div className="company-job-cell company-job-action">
            <div>
              <p className="mb-1 jobPara">Share</p>
              <div className="cursor d-flex justify-content-center">
                <ShortcutIcon
                  className="viewBlue"
                  onClick={() => {
                    setShareurl(`/view-job-details/${jobs?._id}`);
                    setShow(1);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr className="m-0" />
    </div>
  );

  return (
    <Col>
      <ShareOption showshare={showshare} handleCloseshare={handleCloseshare} />
      <ShareModel
        handleClosemodal={handleClosemodal}
        show={show}
        handleShowshare={handleShowshare}
        shareurl={shareurl}
      />
      {/* <CandidatesBox showoneModal={showoneModal} handleClose={handleCloses} /> */}
      <div>
        <Adds back="/find-job" />
      </div>
      <div className="position-relative">
        <div className="position-absolute search-absolute company-job-search">
          <Form
            className="position-relative"
            onFocus={handleFocus}
            onBlur={handleBlur}
          >
            <FormControl
              type="text"
              placeholder="Search"
              className="mr-sm-2 search-buing-area"
              name="title"
              onChange={(e) => filterData(e.target.value)}
            />
          </Form>
        </div>
        <Tabs
          defaultActiveKey="jobs"
          id="uncontrolled-tab-example"
          className="mb-3"
          onSelect={(k) => handleTabSelect(k)}
        >
          <Tab eventKey="jobs" title="Jobs">
            <div className="scroll-company-jobs noscroll">
              {companysearchdata && companysearchdata.length > 0 ? (
                companysearchdata.map((jobs) => renderJobRow(jobs))
              ) : companyJobsLoading ? (
                <p className="text-muted text-center p-3 mb-0">Loading jobs…</p>
              ) : jobsToShow.length > 0 ? (
                jobsToShow.map((jobs) => renderJobRow(jobs))
              ) : (
                <p className="text-muted text-center p-3 mb-0">
                  No jobs posted by this company yet.
                </p>
              )}
            </div>
          </Tab>
          {/* <Tab eventKey="tab1" title="Connects" variant="primary"></Tab> */}
        </Tabs>
      </div>
    </Col>
  );
};
export default JobList;
